import React, { createRef } from "react";
// Redux
import { connect } from "react-redux";

import { Container, Row, Col } from "reactstrap";

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";

import { find, filter } from "lodash";

import logo from "../assets/images/logo-main.png";

import Emitter from "helpers/emitter_helper";

import Wizard from "components/Wizard";

import Tramite from "./Steps/Tramite";
import Disponibilidad from "./Steps/Disponibilidad";
import Sucursal from "./Steps/Sucursal";
import SucursalAlt from "./Steps/SucursalAlt";
import Fecha from "./Steps/Fecha";
import FechaAlt from "./Steps/FechaAlt";
import Datos from "./Steps/Datos";
import Confirmacion from "./Steps/Confirmacion";
import ReactGA from 'react-ga';


import { getBranches, getSchedules, createAppointment } from "store/actions";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      steps: [
        { stepName: "Datos", component: Datos, stepIcon: "mdi mdi-account-circle" },
        { stepName: "Agenda", component: Tramite, stepIcon: "mdi mdi-clipboard-text" },
        { stepName: "Fecha y hora", component: Fecha, stepIcon: "mdi mdi-calendar" },
        { stepName: "Confirmación", component: Confirmacion, stepIcon: "mdi mdi-check-circle" }
      ],
      breadcrumb: {
        tramite: {
          title: '',
          icon: 'mdi mdi-clipboard-text'
        },
        sucursal: {
          title: '',
          icon: 'mdi mdi-domain'
        },
        fecha: {
          title: '',
          icon: 'mdi mdi-calendar'
        }
      },
      success_msg: false,
      error_msg: false
    };
  }

  componentDidMount() {

    this.props.getBranches();
    this.props.getSchedules(null, (result) => this.onGetSchedules(result));
  }

  componentWillUnmount() {
  }

  finish(allStates) {
    console.log('All states:', allStates);
    // Usar branch id de Sedes o de Branch
    let branchId = null;
    if (allStates['Sedes'] && allStates['Sedes'].branch) {
      branchId = allStates['Sedes'].branch;
    } else if (allStates['Branch'] && allStates['Branch'].branch) {
      branchId = allStates['Branch'].branch;
    }
    const tramites = filter(this.props.schedules, (s) => {
      return s.name == allStates['Agenda'].scheduleName;
    });
    const tramite = filter(tramites, (s) => {
      return find(s.branches, { id: branchId });
    })[0];

    // Construir customer solo con el documento seleccionado
    const datos = allStates['Datos'].values;
    let customer = {
      firstName: datos.firstName,
      lastName: datos.lastName,
      phone: datos.phone,
      email: datos.email,
     // gender: datos.gender,
      additionalData: {
          name: datos.gender
        },
      extraFields: [
        {
            "showable": [
                {
                    "in": "workstation",
                    "format": "both"
                }
            ],
            "legal": datos.acceptTerms
        }
      ],
      businessName: datos.nationality,
      acceptTerms: datos.acceptTerms
    };
    if (datos.docType === 'dni') {
      customer.dni = datos.dni;
    }
    if (datos.docType === 'pasaporte') {
      customer.passport = datos.passport;
    }
    if (datos.docType === 'rut') {
      customer.cedulaIdentidad = datos.rut;
    }

    let payload = {
      branch: {
        id: branchId
      },
      schedule: {
        id: tramite ? tramite.id : null
      },
      startAt: allStates['Fecha y hora'].startAt,
      endAt: allStates['Fecha y hora'].endAt,
      customer
    }
    console.log('Payload to create appointment:', payload);
    this.props.createAppointment(payload, (result) => this.onAppointmentCreate(result));
  }

  onAppointmentCreate(result) {
    if (result) {
      this.setState({ success_msg: true });
    } else {
      this.setState({ error_msg: true });
    }
  }

  onGetSchedules(result) {
    if (result) {
      if (this.props.match.params.tramite) {
        setTimeout(() => {
          Emitter.emit('TRAMITE_FROM_URL', this.props.match.params.tramite);
        }, 1500);
      }
    }
  }

  render() {
    return (
      <Container>
        <Row className="justify-content-center mt-3 mb-3">
          <Col>
            <div className="text-center">
              <img src={logo} alt="Ministerio de Relaciones Exteriores - Solicitud de turnos" className="img-fluid" />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Wizard
              title="Solicitud de turnos"
              steps={this.state.steps}
              breadcrumb={this.state.breadcrumb}
              headerTextCenter
              validate
              color="primary"
              finishButtonText="Finalizar"
              finishButtonClick={this.finish.bind(this)}
              finishButtonClasses="btn-success"
              previousButtonText="Anterior"
              nextButtonText="Siguiente"
              nextButtonClasses="btn-primary"
              type={this.state.type}
            />
            {this.state.success_msg ? (
              <SweetAlert
                title="¡Gracias por elegirnos!"
                success
                confirmBtnBsStyle="success"
                confirmBtnText="Aceptar"
                onConfirm={() => {
                  if (process.env.REACT_APP_THANK_YOU_PAGE_URL) {
                    window.top.location = process.env.REACT_APP_THANK_YOU_PAGE_URL;
                  } else {
                    window.location.reload();
                  }
                }}
              >
                Te enviamos un correo electrónico con todos los datos de tu turno.
              </SweetAlert>
            ) : null}
            {this.state.error_msg ? (
              <SweetAlert
                title="Error!"
                error
                confirmBtnBsStyle="danger"
                confirmBtnText="Aceptar"
                onConfirm={() => this.setState({ error_msg: false })}
              >
                {this.props.error.apiMessage == 'API_APPOINTMENTS_CREATE_MAX_NUMBER_OF_APPOINTMENTS_PER_CUSTOMER_PER_DAY_REACHED' ? 'Se alcanzó el límite máximo establecido de citas por cliente por día.' : 'Ha ocurrido un error. Por favor, intente nuevamente'}
              </SweetAlert>
            ) : null}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const { schedules, error } = state.Home;
  return {
    schedules, error
  };
}

export default connect(mapStateToProps, {
  getBranches,
  getSchedules,
  createAppointment
})(Home);
